import React from "react";
import Header from "../components/marpay/Header";
import HeroCarousel from "../components/marpay/HeroCarousel";
import Marquee from "../components/marpay/MarqueeRibbon";
import Stats from "../components/marpay/Stats";
import TherapeuticAreas from "../components/marpay/TherapeuticAreas";
import Testimonials from "../components/marpay/Testimonials";
import Contact from "../components/marpay/Contact";
import Footer from "../components/marpay/Footer";
import WhatsAppCTA from "../components/marpay/WhatsAppCTA";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="bg-[var(--mp-bg)] text-[var(--mp-text)]">
      <Header />
      <HeroCarousel />
      <Marquee />
      <Stats />
      <TherapeuticAreas />
      <Testimonials />
      <Contact />
      <Footer />
      <WhatsAppCTA />
    </main>
  );
}
